export default __webpack_public_path__ + "static/media/Connecticut5.8e2252fa.png";